import { UNASSIGNED_OPERATOR } from '@app/constants/general';
import { BULK_CASE_ACTION_KIND } from '@app/constants/queue';
import type { BulkCaseActionRunComplete } from '@app/services/bulk-case-action';

export const BULK_RUN_COPY = {
  QUEUE: 'queue',
  QUEUE_REMOVE: 'queueRemove',
  ASSIGN: 'assign',
  UNASSIGN: 'unassign',
  CLOSE: 'close',
} as const;

export type BulkRunCopy = (typeof BULK_RUN_COPY)[keyof typeof BULK_RUN_COPY];

const bulkRunCopy = (
  run: Pick<BulkCaseActionRunComplete, 'kind' | 'payload'> | undefined,
): BulkRunCopy => {
  if (run?.kind === BULK_CASE_ACTION_KIND.CASE_CLOSE) {
    return BULK_RUN_COPY.CLOSE;
  }
  if (run?.kind === BULK_CASE_ACTION_KIND.OPERATOR_SET) {
    return run.payload?.operatorId === UNASSIGNED_OPERATOR
      ? BULK_RUN_COPY.UNASSIGN
      : BULK_RUN_COPY.ASSIGN;
  }
  if (run?.kind === BULK_CASE_ACTION_KIND.QUEUE_REMOVE) {
    return BULK_RUN_COPY.QUEUE_REMOVE;
  }
  return BULK_RUN_COPY.QUEUE;
};

export default bulkRunCopy;
